import gql from "graphql-tag";

export const GET_LOOKUPS = gql`
query getLookups(
	$type: String!
	$skip: Int
	$take: Int
	$where: LookupFilterInput
	$order: [LookupSortInput!]
	){
    lookups(
    	type: $type
    	skip: $skip
		take: $take
		where: $where
		order: $order
    ) {
        pageInfo {
            hasNextPage
            hasPreviousPage
        }
        items {
          id,
          type,
          code,
          description
        }
    }
}
`;
